export default "__VITE_ASSET__yseK6Ll0__"